export default "__VITE_ASSET__bf14212c__"